import i18n from "../../../i18n";
import {
  convertToUserTimezone,
  getEffectiveAdminTimezone,
} from "../../../utils/dateService";
import { EMPTY_DISPLAY } from "./constants";

// Locale-keyed formats; kept here so dateService stays unchanged.
const LIST_TABLE_DATETIME_FORMAT_BY_LOCALE: Record<string, string> = {
  en: "MM/DD/YY hh:mm A",
  "pt-BR": "DD/MM/YY HH:mm",
  es: "DD/MM/YY HH:mm",
  de: "DD.MM.YY HH:mm",
};

const formatForActiveLocale = (): string => {
  const lng = i18n.resolvedLanguage || i18n.language || "en";
  return LIST_TABLE_DATETIME_FORMAT_BY_LOCALE[lng] ?? LIST_TABLE_DATETIME_FORMAT_BY_LOCALE.en;
};

/** Localized Start/End and Templates Created/Updated display. */
export const formatListTableDateTime = (
  iso: string | null | undefined,
): string => {
  if (!iso) return EMPTY_DISPLAY;
  return convertToUserTimezone(
    iso,
    formatForActiveLocale(),
    getEffectiveAdminTimezone(),
  );
};
